<div class="lp-wrapper" (window:resize)="onResize($event)">
  <div *ngIf="loading" class="lp-status">Loading…</div>
  <div *ngIf="!loading && errorMsg" class="lp-status lp-error">{{ errorMsg }}</div>

  <ngx-charts-bar-horizontal-2d
    *ngIf="!loading && !errorMsg"
    [results]="chartData"
    [view]="viewsize"
    [xAxis]="showXAxis"
    [yAxis]="showYAxis"
    [legend]="showLegend"
    [showXAxisLabel]="showXAxisLabel"
    [showYAxisLabel]="showYAxisLabel"
    [xAxisLabel]="xAxisLabel"
    [yAxisLabel]="yAxisLabel"
    [trimXAxisTicks]="false"
    [trimYAxisTicks]="true"
    [maxYAxisTickLength]="yAxisMaxLabelLength">
  </ngx-charts-bar-horizontal-2d>
</div>
